<template>
    <div class="view-bar-header">
        <h1>
            <slot/>

        </h1>
        <div class="view-bar-header-actions">
            <small-icon-button :icon="action.icon" @press="emitAction(action.name)" v-for="action in actions"/>
        </div>
    </div>
</template>

<script>
    import SimpleButton from "../button/SimpleButton";
    import SmallIconButton from "../button/SmallIconButton";
    export default {
        name: "ViewBarHeader",
        props: {
            actions: Array
        },
        methods: {
            emitAction(name) {
                this.$emit(name);
            }
        },
        components: {SmallIconButton, SimpleButton}
    }
</script>

<style lang="scss" scoped>
.view-bar-header {
    padding: 10px;
    display: grid;
    grid-template: 1fr / 1fr min-content;
    align-items: center;
    justify-content: center;
}

.view-bar-header-actions {
    * {
        margin-left: 5px;
    }
    display: flex;
    flex-flow: row;

}
</style>